import { render, staticRenderFns } from "./categories-button-action.vue?vue&type=template&id=5f64053c&"
import script from "./categories-button-action.vue?vue&type=script&lang=js&"
export * from "./categories-button-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports